module.exports = __webpack_public_path__ + "static/img/get_un_cocktail.9835a961.png";